import React, { Component } from 'react';
import { connect } from 'react-redux';
import IntlMessages from 'util/IntlMessages';
import { injectIntl, intlShape } from 'react-intl';
import CardLayout from 'components/CardLayout/index';
import { Modal, Button } from 'reactstrap';
import { checkPasswordRequirements } from 'helperfunctions';
import { updateUserPassword } from 'actions/UserProfile';
class ExpiredPasswordModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			passwordOldValue: '',
			passwordNewValue: '',
			passwordRepeatValue: '',
			invalid: {
				passwordOld: false,
				passwordNew: false,
				passwortRepeat: false
			}
		};
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.passwordOldInvalid && this.props.passwordOldInvalid) this.setState({ invalid: { passwordOld: true } });
	}

	onSetNewPassword = () => {
		const { passwordNewValue, passwordRepeatValue, passwordOldValue, invalid } = this.state;
		if (passwordNewValue !== passwordRepeatValue) return this.setState({ invalid: { ...invalid, passwordRepeat: true } });
		if (!checkPasswordRequirements(passwordNewValue, this.props.passwordRequirements))
			return this.setState({ invalid: { ...invalid, passwordNew: true } });
		this.props.updateUserPassword(passwordOldValue, passwordNewValue);
	};

	render() {
		const { invalid, passwordOldValue, passwordRepeatValue, passwordNewValue } = this.state;
		const { minPasswordLength, minPasswordCategories } = this.props.passwordRequirements;
		const { modalWidth, modalHeight, onClose } = this.props;
		return (
			<div className="text-center">
				<Modal
					style={{
						width: modalWidth || 400,
						height: modalHeight || 100
					}}
					isOpen={true}
					toggle={onClose}
				>
					<CardLayout styleName="col-lg-12 m-0">
						<div className="jr-card-header mb-3 text-center">
							<h3 className="card-heading mb-0">
								<IntlMessages id="passwordExpiredModal.title" />
							</h3>
						</div>
						<div className="row">
							<div className="col-12">
								<p>
									<IntlMessages id="passwordExpiredModal.info" />
								</p>
								<div className="form-group">
									<input
										className={`form-control form-control-lg ${invalid.passwordOld ? 'is-invalid' : ''}`}
										value={passwordOldValue}
										onChange={m =>
											this.setState({
												passwordOldValue: m.target.value,
												invalid: { passwordOld: false }
											})
										}
										type="password"
										placeholder={this.props.intl.formatMessage({
											id: 'passwordExpiredModal.passwordOld'
										})}
									/>
									<div className="invalid-feedback">
										<IntlMessages id="passwordExpiredModal.passwordOld.invalidText" />
									</div>
								</div>
								<div className="form-group">
									<input
										className={`form-control form-control-lg ${invalid.passwordNew ? 'is-invalid' : ''}`}
										value={passwordNewValue}
										onChange={m =>
											this.setState({
												passwordNewValue: m.target.value,
												invalid: { passwordNew: false }
											})
										}
										type="password"
										placeholder={this.props.intl.formatMessage({
											id: 'passwordExpiredModal.passwordNew'
										})}
									/>
									<div className="invalid-feedback">
										<IntlMessages id="passwordExpiredModal.passwordNew.invalidText" />
									</div>
									<small className="form-text text-muted text-left small">
										<IntlMessages
											id="common.passwordRequirementsInfo"
											values={{
												minPasswordLength: minPasswordLength || 8,
												minPasswordCategories: minPasswordCategories || 3
											}}
										/>
									</small>
								</div>
								<div className="form-group">
									<input
										className={`form-control form-control-lg ${invalid.passwordRepeat ? 'is-invalid' : ''}`}
										value={passwordRepeatValue}
										onChange={m =>
											this.setState({
												passwordRepeatValue: m.target.value,
												invalid: { passwordRepeat: false }
											})
										}
										type="password"
										placeholder={this.props.intl.formatMessage({
											id: 'passwordExpiredModal.passwordRepeat'
										})}
									/>
									<div className="invalid-feedback">
										<IntlMessages id="passwordExpiredModal.passwordRepeat.invalidText" />
									</div>
								</div>
							</div>
							<div className="col-12">
								<Button
									color="default"
									className="jr-btn jr-btn-default bg-blue text-uppercase btn-block text-white"
									onClick={this.onSetNewPassword}
									disabled={this.props.loading}
								>
									{this.props.loading ? (
										<i className="zmdi zmdi-spinner zmdi-hc-spin" />
									) : (
										<IntlMessages id="passwordExpiredModal.action" />
									)}
								</Button>
							</div>
						</div>
					</CardLayout>
				</Modal>
			</div>
		);
	}
}

function mapStateToProps({ profile, accountSettings }) {
	const { passwordExpired } = profile.myUserProfile;
	const { passwordRequirements } = accountSettings.organisationStructure;
	return {
		passwordExpired,
		passwordRequirements,
		passwordOldInvalid: profile.updateUserPasswordInvalidOldPassword,
		loading: profile.loading.updateUserPassword
	};
}

ExpiredPasswordModal.propTypes = {
	intl: intlShape.isRequired
};

export default connect(
	mapStateToProps,
	{ updateUserPassword }
)(injectIntl(ExpiredPasswordModal));



// WEBPACK FOOTER //
// ./containers/ExpiredPasswordModal/index.js